const settings = require('./../classes/settings.js');
import Event from './event.js';

export default class Notification {
    static LINKED_MODULES = [settings.modules.companies, settings.modules.projects, settings.modules.workflows, settings.modules.users];

    constructor(item) {
        if (item) {
            for (const key in item) {
                if (item.hasOwnProperty(key)) {
                    this[key] = item[key];
                }
            }
        }
    }

    getSeverity(){
        return Event.getSeverity(this.severity);
    }
}